import React from 'react';

export default function ComingSoon({ label, icon, desc }) {
  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: '32px 48px 60px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 40px', textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 20, opacity: 0.4 }}>{icon}</div>
        <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 28, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#fff', marginBottom: 10 }}>{label}</h2>
        <p style={{ fontSize: 14, color: '#aaa', maxWidth: 380, lineHeight: 1.6 }}>{desc}</p>
        <div style={{ marginTop: 20, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', padding: '5px 14px', borderRadius: 2, background: 'rgba(255,255,255,0.06)', color: '#666', border: '1px solid #3a3a3a' }}>Coming Soon</div>
      </div>
    </div>
  );
}
